import { BrandColors } from './brandColors';
/* Colors are in CSS HEX codes */

export interface IAccessibilityProfile {
  id: number;
  label: string;
  default: string;
  primary: string;
  secondary: string;
  bgColor: string;

  /** Localization id */
  locId?: string;

  /** App header color */
  headerColor?: string;

  /** Menu icon color */
  iconColor?: string;

  /** Label and popups border color */
  borderColor?: string;

  /** Header logo filter */
  logoFilter?: string;

  /** Footer Shadow Color */
  footerShadowColor?: string;

  /** Anchor tag text color */
  anchorColor?: string;

  /** Watch Again Icon Fill Color */
  watchAgainIconFill?: string;

  /**Watcj Again Icon Stroke Color */
  watchAgainIconStroke?: string;

  /** Progess bar text Color */
  progessBarTextColor?: string;
}

export const AccessibilityProfiles: IAccessibilityProfile[] = [
  {
    id: 0,
    label: 'Default',
    locId: 'playerAccessibilityWidgetDefault',
    default: '',
    primary: '',
    secondary: '',
    bgColor: '',
    headerColor: '#FFF',
    iconColor: '#5D676F',
    borderColor: '#00000000',
    footerShadowColor: 'rgba(0, 0, 0, 0.25)',
    anchorColor: '#53B1DB',
    watchAgainIconFill: '#53B1DB',
    watchAgainIconStroke: '#FFFFFF',
    progessBarTextColor: '#5D676F',
  },
  {
    id: 1,
    label: 'Off-White/Black',
    locId: 'playerAccessibilityWidgetOffWhiteBlack',
    default: '#000000',
    primary: '#000000',
    secondary: '#FFFFE6',
    bgColor: '#FFFFE6',
    headerColor: '#000000',
    iconColor: '#FFFFE6',
    borderColor: '#000000',
    logoFilter: 'brighten',
    footerShadowColor: 'rgba(0, 0, 0, 0.25)',
    anchorColor: '#059DF5',
    watchAgainIconFill: '#FFFFE6',
    watchAgainIconStroke: '#000000',
    progessBarTextColor: '#5B6770',
  },
  {
    id: 2,
    label: 'Black/White',
    locId: 'playerAccessibilityWidgetBlackWhite',
    default: '#FFFFFF',
    primary: '#FFFFFF',
    secondary: '#000000',
    bgColor: '#000000',
    headerColor: '#FFFFFF',
    iconColor: '#000000',
    borderColor: '#FFFFFF',
    logoFilter: 'darken',
    footerShadowColor: '#FFFFFF',
    anchorColor: '#0472A0',
    watchAgainIconFill: '#000000',
    watchAgainIconStroke: '#FFFFFF',
    progessBarTextColor: '#9A9EA1',
  },
  {
    id: 3,
    label: 'Blue/Yellow',
    locId: 'playerAccessibilityWidgetBlueWhite',
    default: '#F1D700',
    primary: '#F1D700',
    secondary: '#0C23FB',
    bgColor: '#0C23FB',
    headerColor: '#F1D700',
    iconColor: '#0C23FB',
    borderColor: '#F1D700',
    footerShadowColor: 'rgba(0, 0, 0, 0.25)',
    anchorColor: '#003F7A',
    watchAgainIconFill: '#0C23FB',
    watchAgainIconStroke: '#F1D700',
    progessBarTextColor: '#C4C4C4',
  },
];

export interface AccessibilityThemesProps {
  id: number;
  label: string;
  primaryColor: string;
  secondaryColor: string;
  disabledBackgroundColor: string;
}

// primaryColor - text color ,   secondaryColor - background color
export const AccessibilityThemes: AccessibilityThemesProps[] = [
  {
    id: 1,
    label: 'playerAccessibilityWidgetDefault',
    primaryColor: '#000000',
    secondaryColor: '#FFFFFF',
    disabledBackgroundColor: BrandColors.grey95,
  }, // default
  {
    id: 2,
    label: 'accessibilityThemeBlackCream',
    primaryColor: '#000000',
    secondaryColor: '#FFFFE8',
    disabledBackgroundColor: '#aaaa9c', // #FFFFEA (66%) + #000000 (33% opacity)
  }, // black/cream
  {
    id: 3,
    label: 'accessibilityThemeYellowBlue',
    primaryColor: '#F8CC55',
    secondaryColor: '#0C22FA',
    disabledBackgroundColor: '#0022a0', // #0033F0 (66%) + #000000 (33% opacity)
  }, // blue/yellow
  {
    id: 4,
    label: 'accessibilityThemeWhiteBlack',
    primaryColor: '#FFFFFF',
    secondaryColor: '#000000',
    disabledBackgroundColor: '#aaaaaa', // #FFFFFF (66%) + #000000 (33% opacity)
  }, // black/white
  {
    id: 5,
    label: 'accessibilityThemeBlackMagenta',
    primaryColor: '#000000',
    secondaryColor: '#E08AE8',
    disabledBackgroundColor: '#8d6097', // #D490E3 (66%) + #000000 (33% opacity)
  }, // black/magenta
  {
    id: 6,
    label: 'accessibilityThemeBlackGreen',
    primaryColor: '#000000',
    secondaryColor: '#A5AC9F',
    disabledBackgroundColor: '#6e736a', // #A5AC9F (66%) + #000000 (33% opacity)
  }, // black/green
  {
    id: 7,
    label: 'accessibilityThemeWhiteTeal',
    primaryColor: '#FFFFFF',
    secondaryColor: '#008080',
    disabledBackgroundColor: '#005555', // #008080 (66%) + #000000 (33% opacity)
  }, // white/teal
];
